import { PayloadAction } from '@reduxjs/toolkit';
import { fork, take, call, delay, put, takeLatest } from 'redux-saga/effects';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import { push } from 'connected-react-router';
import { AxiosResponse } from 'axios';
import { useTranslation } from 'react-i18next';

import { ENCODE_SECRET_KEY } from '../constants';
import { authActions, LoginPayload } from '../slices/authSlice';
import { errorToast } from '../helpers/AlertHelper';
import { shopListAction } from 'slices/shopSlice';
import { getPermissionAPI, loginAPI, logoutAPI } from 'redux/api';
import customHistory from 'utils/customHistory';
import { RankingMasterInformation } from 'models';

function* handleLogin(action: any) {
  const { email, password, remember_me } = action.payload.state;
  try {
    const res: AxiosResponse = yield call(loginAPI, {
      email: email.includes('@') ? email : email + '@gmail.com',
      password,
      remember_me: remember_me,
    });
    const { data } = res;

    if (data.access_token) {
      // localStorage.setItem('POS_DAILY_USER_ID', data.user.id);
      Cookies.set(
        'POS_CUSTOMER_PAYMENT_TOKEN',
        CryptoJS.AES.encrypt(data.access_token, ENCODE_SECRET_KEY).toString(),
        {
          expires: remember_me ? 365 : 7,
        }
      );
      yield put(authActions.loginSuccess(data));
      customHistory.push('/select-shop');
    } else if (data.message && data.message === 'Invalid Credentials') {
      errorToast('メールアドレスまたはパスワードが間違っています！');
      yield delay(2000);
      const win: Window = window;
      win.location.reload();
    }
  } catch (error) {
    errorToast('ログインに失敗しました');
  }
}

function* handleLogout(action: any) {
  const { token, notification_token } = action.payload;
  try {
    const res: AxiosResponse = yield call(logoutAPI, token, { notification_token });
    if (res) {
      Cookies.remove('POS_CUSTOMER_PAYMENT_TOKEN');
      Cookies.remove('POS_DAILY_USER_ID');
      yield put(shopListAction.removeShopList());
      yield put(authActions.logoutSuccess());
      customHistory.push('/auth');
      // window.location.href = '/';
      // const win: Window = window;
    }
  } catch (error) {
    Cookies.remove('POS_CUSTOMER_PAYMENT_TOKEN');
    localStorage.removeItem('ID_SELECTED_SHOP');
    localStorage.removeItem('SELECTED_SHOP_ID');
    localStorage.removeItem('selectedShop');
    localStorage.removeItem('shopSetting');
    localStorage.removeItem('masterInfo');

    // yield put(push('/'));
    // const win: Window = window;
  }
}

function* watchLoginFlow() {
  while (true) {
    const isLoggedIn = Boolean(Cookies.get('POS_CUSTOMER_PAYMENT_TOKEN'));

    if (!isLoggedIn) {
      const action: PayloadAction<LoginPayload> = yield take(authActions.login.type);
      yield fork(handleLogin, action);
    }
    const actionLogout: PayloadAction<LoginPayload> = yield take(authActions.logout.type);
    yield call(handleLogout, actionLogout);
  }
}
function* getMasterPermissionSaga(action: PayloadAction<{ token: string }>) {
  try {
    const { token } = action.payload;
    const res: AxiosResponse<Array<RankingMasterInformation>> = yield call(getPermissionAPI, token);
    const { status, data } = res;
    if (status == 200) {
      yield put(
        authActions.getMasterPermissionSuccess(
          data.find((item) => item.name == 'enable_ranking_master' && item.active == 1) ||
            ({} as RankingMasterInformation)
        )
      );
    }
  } catch (error) {
    console.log('get list permission failed');
    yield put(authActions.getMasterPermission);
  }
}
export default function* authSaga() {
  yield fork(watchLoginFlow);
  yield takeLatest(authActions.getMasterPermission.type, getMasterPermissionSaga);
}

// export default function* authSaga() {
//   yield takeEvery(authActions.login.type, handleLogin);
//   yield takeEvery(authActions.logout.type, handleLogout);
// }
